namespace $ {

	export class $shm_hitalama_map_history_storage_entry {

		constructor(
			private readonly history: $shm_hitalama_map_history,
			private readonly summary: $shm_hitalama_map_history_summary,
		) {}

		link() {
			return new this.history.$.$giper_baza_link( this.summary.e )
		}

		time() {
			return this.summary.t
		}

		author() {
			return this.summary.a
		}

		peer() {
			return this.summary.p
		}

		data() {
			return this.summary.d
		}

		full() {
			return this.history.event_by_link( this.summary.e )
		}

	}

}
